<!--
 * @Author: your name
 * @Date: 2022-01-19 09:29:09
 * @LastEditTime: 2022-04-26 13:45:09
 * @LastEditors: Smart Chow
 * @Description: 患者选择弹框
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-check/check/_components/dialog/CheckedPatientsDialog.vue
-->
<template>
  <div>
    <patient-360
      v-if="patientVisible"
      class="pdf-model"
      :dialogVisible="patientVisible"
      :patientUrl="patientUrl"
      :clickBack="patientClose"
    ></patient-360>
    <w-modal
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :title="title || '被查患者'"
      width="70%"
      :before-close="cancel"
      :append-to-body="true"
      custom-class="wn-dialog"
    >
      <div>
        <div v-show="currentPersons.length > 0 && ifShow" class="tag-warp">
          <div class="tag-panel" :class="{ collapse: isCollapse }">
            <w-tag
              v-for="(tag, index) in currentPersons"
              :key="index"
              closable
              @close="handleClose(tag, index)"
            >
              {{ tag.Name }}
            </w-tag>
          </div>
          <div
            v-show="currentPersons.length > 4"
            class="tag-arrow"
            @click="isCollapse = !isCollapse"
          >
            折叠
            <i
              class="w-icon-arrow-bottom"
              :class="{ 'w-icon-arrow-top': isCollapse }"
            ></i>
          </div>
        </div>
        <w-tabs
          v-model="activeTab"
          size="large"
          class="dialog-tabs"
          @tab-click="changeTab"
        >
          <w-tab-pane label="住院" name="hospitalization"></w-tab-pane>
          <w-tab-pane label="门诊" name="OutpatientDepartment"></w-tab-pane>
        </w-tabs>

        <div class="search-panel">
          <w-form label-align="right" size="small" label-width="80px">
            <w-row :gutter="10">
              <w-col :span="7">
                <w-form-item
                  :label="`${
                    activeTab === 'hospitalization' ? '入院日期' : '就诊日期'
                  }:`"
                >
                  <MutipleDateSelect
                    ref="dateRange"
                    v-model="formObject.dateRange"
                  ></MutipleDateSelect>
                </w-form-item>
              </w-col>
              <w-col :span="5">
                <w-form-item
                  label="科室:"
                  label-width="45px"
                  style="font-size: none; text-align: left"
                >
                  <w-select
                    v-model="formObject.Ksdm"
                    class="input-select"
                    placeholder="请选择(可输入筛选)"
                    style="width: 100%"
                    filterable
                    multiple
                    clearable
                    show-checkbox
                    collapse-tags
                  >
                    <w-option
                      v-for="item in KsList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </w-option>
                  </w-select>
                </w-form-item>
              </w-col>
              <w-col v-if="activeTab === 'hospitalization'" :span="5">
                <w-form-item label="病区:">
                  <w-select
                    v-model="formObject.Bqdm"
                    class="input-select"
                    placeholder="请选择(可输入筛选)"
                    style="width: 100%"
                    filterable
                    multiple
                    clearable
                    collapse-tags
                  >
                    <w-option
                      v-for="item in BqList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </w-option>
                  </w-select>
                </w-form-item>
              </w-col>
              <w-col v-if="activeTab === 'hospitalization'" :span="6">
                <w-form-item label="患者类型:">
                  <w-select
                    v-model="formObject.Hzlx"
                    class="input-select"
                    placeholder="请选择(可输入筛选)"
                    style="width: 100%"
                    filterable
                    clearable
                    collapse-tags
                  >
                    <w-option
                      v-for="item in HzlxList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </w-option>
                  </w-select>
                </w-form-item>
              </w-col>
            </w-row>
            <w-row class="mt-10">
              <w-col :span="12">
                <w-form-item label="关键词:">
                  <w-input
                    v-model.trim="formObject.UserCode"
                    size="small"
                    :placeholder="
                      activeTab === 'hospitalization'
                        ? '患者姓名/ 床位号/ 首页序号/ 住院号/ 身份证号'
                        : '患者姓名/ 门诊号/ 病历号/ 身份证号'
                    "
                    class="searchKey-box"
                    clearable
                    @keyup.enter.native="changeTab()"
                  >
                  </w-input>
                </w-form-item>
              </w-col>
              <w-col :span="2">
                <w-button
                  size="small"
                  style="margin-left: 15px"
                  type="primary"
                  @click="changeTab()"
                >
                  查询
                </w-button>
              </w-col>
            </w-row>
          </w-form>
        </div>

        <div v-if="activeTab === 'hospitalization'">
          <WnTable :list-query.sync="listQuery" @fetchData="fetchData">
            <vxe-table
              class="hospitalTable"
              id="hospitalTable"
              ref="hospitalTable"
              v-win-loading="loading"
              row-id="ID"
              height="340"
              :data="hospitalizationData"
              border
              stripe
              highlight-current-row
              :row-config="{ isHover: true }"
              :column-config="{ resizable: true }"
              :checkbox-config="{
                checkRowKeys: selectRows,
                highlight: true,
                checkStrictly: true
              }"
              :sort-config="{
                remote: true
              }"
              @sort-change="sortChange"
              @checkbox-change="handleselectRow"
            >
              <vxe-column type="checkbox" width="50" title="选择"></vxe-column>
              <vxe-column
                sortable
                field="CWDM"
                width="90"
                title="床位号"
              ></vxe-column>
              <vxe-column
                sortable
                field="BLH"
                width="100"
                title="首页序号"
              ></vxe-column>
              <vxe-column
                sortable
                field="ZYH"
                width="130"
                title="住院号"
              ></vxe-column>
              <vxe-column
                sortable
                field="HZXM"
                width="100"
                title="患者姓名"
                show-tooltip
              ></vxe-column>
              <vxe-column
                sortable
                field="SEX"
                width="80"
                title="性别"
              ></vxe-column>
              <vxe-column
                field="SFZHM"
                width="160"
                title="身份证号"
              ></vxe-column>
              <vxe-column sortable field="KSName" title="科室"></vxe-column>
              <vxe-column sortable field="BQName" title="病区"></vxe-column>
              <vxe-column
                sortable
                field="RYRQ"
                width="180"
                title="入院日期"
              ></vxe-column>
              <vxe-column
                v-if="xtmj1259 == '1'"
                field=""
                width="100"
                title="操作"
              >
                <template slot-scope="scope">
                  <span
                    style="color: blue; cursor: pointer"
                    @click="patientInfo(scope.row.PatientUrl)"
                    >患者360</span
                  >
                </template>
              </vxe-column>
            </vxe-table>
          </WnTable>
        </div>
        <div v-show="activeTab === 'OutpatientDepartment'">
          <WnTable :list-query.sync="listQuery" @fetchData="fetchData">
            <vxe-table
              class="OutpatientDepartTable"
              id="OutpatientDepartTable"
              ref="OutpatientDepartTable"
              v-win-loading="loading"
              row-id="ID"
              height="340"
              :data="outpatientDepartData"
              border
              stripe
              highlight-current-row
              :row-config="{ isHover: true }"
              :column-config="{ resizable: true }"
              :checkbox-config="{
                checkRowKeys: selectRows,
                highlight: true,
                checkStrictly: true
              }"
              :sort-config="{
                remote: true
              }"
              @sort-change="sortChangeTab2"
              @checkbox-change="handleselectRow"
            >
              <vxe-column type="checkbox" width="50" title="选择"></vxe-column>
              <vxe-column sortable field="SYXH" title="门诊号"></vxe-column>
              <vxe-column sortable field="BLH" title="病历号"></vxe-column>
              <vxe-column sortable field="HZXM" title="患者姓名"></vxe-column>
              <vxe-column
                sortable
                field="SEX"
                width="80"
                title="性别"
              ></vxe-column>
              <vxe-column
                field="SFZHM"
                width="160"
                title="身份证号"
              ></vxe-column>
              <vxe-column sortable field="KSName" title="科室"></vxe-column>
              <vxe-column sortable field="RYRQ" title="就诊日期"></vxe-column>
              <vxe-column
                v-if="xtmj1259 == '1'"
                field=""
                width="100"
                title="操作"
              >
                <template slot-scope="scope">
                  <span
                    style="color: blue; cursor: pointer"
                    @click="patientInfo(scope.row.PatientUrl)"
                    >患者360</span
                  >
                </template>
              </vxe-column>
            </vxe-table>
          </WnTable>
        </div>
      </div>
      <span slot="footer" class="wn-fr mt-10">
        <w-button @click="cancel">关 闭</w-button>
        <w-button type="primary" @click="confirm">确 定</w-button>
      </span>
    </w-modal>
  </div>
</template>
<script>
import MutipleDateSelect from '@/common/components/MutipleDateSelect'
import WnTable from '@/common/components/WnTable'
import moment from 'moment'
import { mapState } from 'vuex'
import XEUtils from 'xe-utils'
import patient360 from './Patient360'

export default {
  name: 'CheckedPatientsDialog',
  components: { MutipleDateSelect, WnTable, patient360 },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogClose: {
      type: Function,
      default: () => {}
    },
    basicInfor: {
      type: Object,
      default: () => {
        return {}
      }
    },
    zzjgdm: {
      // 默认组织结构，用于默认勾选关联的his科室或者病区
      type: [String, Number],
      default: () => ''
    },
    title:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      defaultDate: [],
      searchKeyInfo: {
        name: '被查患者', // searchKey-名称
        onlySearch: true,
        hide: false
      },
      activeTab: 'hospitalization',
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        init: false
      },
      formObject: {
        dateRange: [
          moment().add(-1, 'M').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        Bqdm: [],
        Ksdm: [],
        searchKey: '',
        StartTime: '',
        EndTime: '',
        Hzlx: ''
      },
      KsList: [],
      BqList: [],
      HzlxList: [],
      hospitalizationData: [],
      outpatientDepartData: [],
      showFilterQueryList: [],
      loading: false,
      selectRows: [],
      currentPersons: [],
      currentPersonsMap: new Map(),
      isCollapse: false,
      ifShow: false,
      orderTab1: '',
      orderTab2: '',
      xtmj1259: '0',
      patientVisible: false,
      patientUrl: ''
    }
  },
  computed: {
    ...mapState('check', ['zkjb'])
  },
  watch: {
    dialogVisible(val) {
      this.activeTab = 'hospitalization'
      this.formObject.dateRange = []
      this.hospitalizationData = []
      this.outpatientDepartData = []
    }
  },
  async mounted() {
    if (JSON.stringify(this.basicInfor) != '{}') {
      this.ifShow = true
    }
    await this.getSysTemSetting()
  },
  async created() {
    this.activeTab = 'hospitalization'
    let BCBRMCArr = this.basicInfor.BCBRMC ? this.basicInfor.BCBRMC : []
    let BCBRDMArr = this.basicInfor.BCBRDM ? this.basicInfor.BCBRDM : []
    for (let i = 0; i < BCBRMCArr.length; i++) {
      this.currentPersons[i] = {
        Name: BCBRMCArr[i],
        ID: BCBRDMArr[i]
      }
    }
    this.getKsList()
    this.getBqList()
    this.getHzlxList()
    if (this.zzjgdm) {
      await this.GetKsAndBqByZZJG()
    }
    // TODO 删除患者反选逻辑
    // if (this.basicInfor.BCBRDM) {
    //   this.$nextTick(() => {
    //     const ids = this.basicInfor.BCBRDM.split(',')
    //     this.selectRows = ids.map((item) => item + '')
    //     this.$refs.hospitalTable.reloadData()
    //   })
    // } else {
    //   this.selectRows = []
    // }
  },
  methods: {
    // 获取组织结构默认关联的科室和病区
    GetKsAndBqByZZJG() {
      this.$requestApi('GetKsAndBqByZZJG', { zzjgdm: this.zzjgdm }).then(
        (res) => {
          if (res.data) {
            this.formObject.Bqdm = res.data.defaultBq[0]
              ? res.data.defaultBq[0].split(',')
              : []
            this.formObject.Ksdm = res.data.defaultKs[0]
              ? res.data.defaultKs[0].split(',')
              : []
          }
          this.changeTab()
        }
      )
    },
    async getSysTemSetting() {
      this.$requestApi('GetXTMJList', {
        Mjdm: '1259'
      }).then((res) => {
        if (res.success) {
          let data = res.data
          this.xtmj1259 = data.find((item) => item.MJDM == 1259).JLZT
        }
      })
    },
    fetchData(pageNum) {
      if (pageNum) {
        this.listQuery.pageNum = pageNum
        this.listQuery.total = 0
      }

      this.loading = true
      if (this.activeTab === 'hospitalization') {
        this.getDataList()
      } else {
        this.getOutPatientList()
      }
    },
    formatTime({ cellValue, row, column }) {
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:ss:mm')
    },
    changeTab() {
      this.hospitalizationData = []
      this.outpatientDepartData = []
      this.orderTab1 = ''
      this.orderTab2 = ''
      this.fetchData(1)
    },
    // 获取科室代码
    getKsList() {
      let that = this
      this.$requestApi('GetHisKSList').then((res) => {
        if (res.data) {
          this.KsList = res.data
          if (!this.KsList.some((m) => that.formObject.Ksdm.includes(m.id))) {
            that.formObject.Ksdm = []
          }
        }
      })
    },
    // 获取病区代码
    getBqList() {
      let that = this
      this.$requestApi('GetHisBqList', { Zzjgdm: this.zzjgdm }).then((res) => {
        if (res.data) {
          this.BqList = res.data
          if (!this.BqList.some((m) => that.formObject.Bqdm.includes(m.id))) {
            that.formObject.Bqdm = []
          }
        }
      })
    },
    getHzlxList() {
      this.$requestApi('GetHzlxList').then((res) => {
        if (res.data) {
          this.HzlxList = res.data.HzlxList
          this.formObject.Hzlx = res.data.DefaultValue
        }
      })
    },
    //改变科室
    changeSearchForm(detail) {
      this.formObject = JSON.parse(JSON.stringify(detail))
    },
    sortChange({ column, property, order, sortBy, sortList, $event }) {
      let orderArr = new Map() // 展示列和排序列对应关系
      orderArr.set('CWDM', 'cwh')
      orderArr.set('ZYH', 'xh')
      orderArr.set('BLH', 'blh')
      orderArr.set('HZXM', 'hzxm')
      orderArr.set('SEX', 'sex')
      orderArr.set('KSName', 'ksdm')
      orderArr.set('BQName', 'bqdm')
      orderArr.set('RYRQ', 'rq')
      if (orderArr.has(property) && order) {
        this.orderTab1 = `${orderArr.get(property)} ${order}`
      } else {
        this.orderTab1 = ''
      }
      this.getDataList()
    },
    // 获取住院患者信息
    getDataList() {
      let params = {
        UserCode: this.formObject.UserCode,
        StartTime: this.formObject.dateRange[0],
        EndTime: this.formObject.dateRange[1],
        Hzlx: this.formObject.Hzlx,
        Ksdm: this.formObject.Ksdm ? this.formObject.Ksdm.join(',') : '',
        pageIndex: this.listQuery.pageNum,
        PageSize: this.listQuery.pageSize,
        Bqdm: this.formObject.Bqdm ? this.formObject.Bqdm.join(',') : '',
        Order: this.orderTab1,
        Jcfw: this.zzjgdm
      }
      this.$requestApi('GetPatientInfo', params)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.activeTab === 'hospitalization'
              ? (this.hospitalizationData = res.data)
              : (this.outpatientDepartData = res.data)
            if (this.listQuery.pageNum == 1 && res.total > 0) {
              this.listQuery.total = res.total
            }
            // this.activeTab === 'hospitalization'
            //   ? this.$refs.hospitalTable.reloadData(this.hospitalizationData)
            //   : this.$refs.hospitalTable.reloadData(this.outpatientDepartData)
            const table =
              this.activeTab === 'hospitalization'
                ? this.$refs.hospitalTable
                : this.$refs.OutpatientDepartTable
            this.currentPersons.map((v) => {
              let tableData =
                this.activeTab === 'hospitalization'
                  ? this.hospitalizationData
                  : this.outpatientDepartData
              const obj = tableData.find((o) => o.ID === v.ID)
              if (obj) {
                this.$nextTick(() => {
                  table.toggleCheckboxRow(obj, true)
                })
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // tab2排序
    sortChangeTab2({ column, property, order }) {
      let orderArr = new Map() // 展示列和排序列对应关系
      orderArr.set('SYXH', 'xh')
      orderArr.set('BLH', 'blh')
      orderArr.set('HZXM', 'hzxm')
      orderArr.set('KSName', 'ksdm')
      orderArr.set('RYRQ', 'rqdm')
      if (orderArr.has(property) && order) {
        this.orderTab2 = `${orderArr.get(property)} ${order}`
      } else {
        this.orderTab2 = ''
      }
      this.getOutPatientList()
    },
    // 获取门诊患者信息
    getOutPatientList() {
      let params = {
        UserCode: this.formObject.UserCode,
        StartTime: this.formObject.dateRange[0],
        EndTime: this.formObject.dateRange[1],
        Ksdm: this.formObject.Ksdm ? this.formObject.Ksdm.join(',') : '',
        pageIndex: this.listQuery.pageNum,
        PageSize: this.listQuery.pageSize,
        Order: this.orderTab2,
        Jcfw: this.zzjgdm
      }
      this.$requestApi('GetOutPatientInfo', params)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.activeTab === 'hospitalization'
              ? (this.hospitalizationData = res.data)
              : (this.outpatientDepartData = res.data)
            if (this.listQuery.pageNum == 1 && res.total > 0) {
              this.listQuery.total = res.total
            }
            const table =
              this.activeTab === 'hospitalization'
                ? this.$refs.hospitalTable
                : this.$refs.OutpatientDepartTable
            this.currentPersons.map((v) => {
              let tableData =
                this.activeTab === 'hospitalization'
                  ? this.hospitalizationData
                  : this.outpatientDepartData
              const obj = tableData.find((o) => o.ID === v.ID)
              if (obj) {
                this.$nextTick(() => {
                  table.toggleCheckboxRow(obj, true)
                })
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 受检科室切换
    handleChangeDept(row, node, tree) {
      this.deptId = row.id
      this.GetUserInfo()
    },
    // 查询过滤科室
    searchFun(value) {
      this.$nextTick(() => {
        this.$refs.treeSelect.$refs.tree.filter(value)
      })
    },
    patientInfo(url) {
      this.patientUrl = url
      this.patientVisible = true
    },
    patientClose() {
      this.patientVisible = false
    },
    cancel() {
      this.dialogClose()
    },
    confirm() {
      this.dialogClose(this.currentPersons)
    },
    //更换勾选
    handleselectRow(scope) {
      let { checked } = scope
      const index = this.currentPersons.findIndex((o) => o.ID === scope.row.ID)
      let num = this.currentPersonsMap.get(scope.row.ID) || 0
      let type = this.activeTab == 'hospitalization' ? '1' : '0' //1住院患者，0门诊患者
      if (index > -1 && !checked && num == 1) {
        this.currentPersons.splice(index, 1)
      } else if (checked && index == -1) {
        //存在同一个患者、病历号的不同就诊记录
        this.currentPersons.push({
          Name: scope.row.Name,
          ID: scope.row.ID,
          type: type,
          ZRHSList: scope.row.ZRHSList
        })
      }

      // 用于判断出现了多个相同人员的处理，增加map《id-num》，相同人员就增加num的次数
      if (checked) {
        this.currentPersonsMap.set(scope.row.ID, ++num)
      } else {
        this.currentPersonsMap.set(scope.row.ID, --num)
      }
    },
    handleClose(item, index) {
      this.currentPersons.splice(index, 1)
      const table =
        this.activeTab === 'hospitalization'
          ? this.$refs.hospitalTable
          : this.$refs.OutpatientDepartTable
      let tableData =
        this.activeTab === 'hospitalization'
          ? this.hospitalizationData
          : this.outpatientDepartData
      if (tableData.filter((o) => o.ID === item.ID).length > 0) {
        const obj = tableData.find((o) => o.ID === item.ID)
        if (obj) {
          this.$nextTick(() => {
            table.toggleCheckboxRow(obj, false)
          })
        }
      }
    },
    showCollapse() {
      this.isCollapse = true
    }
  }
}
</script>
<style lang="scss" scoped>
.w100 {
  width: 100px;
}
.search-panel {
  padding: 5px 0 10px 0;
}

.input-select {
  width: 400px;
}
.tag-warp {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;

  .tag-arrow {
    line-height: 24px;
    color: var(--COLOR-NORMAL);
    cursor: pointer;
    background: #fff;
    padding: 4px;
    border-radius: 4px;
    &:hover {
      color: var(--COLOR-HOVER);
    }
  }
}
.tag-panel {
  flex: 1;
  min-height: 45px;
  padding-bottom: 3px;
  max-height: 90px;
  overflow: auto;
  white-space: nowrap;
  position: relative;
  &.collapse {
    white-space: normal;
  }
  .w-tag {
    margin: 3px;
  }
}

/deep/ .vxe-cell--label {
  font-family: '宋体';
}

.hospitalTable,
.OutpatientDepartTable {
  /deep/ .vxe-table--body {
    border-bottom: 1px solid #c9c9c9;
  }
}

/deep/ .pdf-model {
  z-index: 999999 !important;
}
</style>
